import { useCallback } from "react";
import Webcam from "react-webcam";

type UseVideoLoadedDataHandlerProps = {
  webcamRef: React.RefObject<Webcam | null>;
  setIsVideoReady: (val: boolean) => void;
  setErrorState: (val: string | null) => void;
};

// Handle when video stream is loaded and ready
export function useVideoLoadedDataHandler({
  webcamRef,
  setIsVideoReady,
  setErrorState,
}: UseVideoLoadedDataHandlerProps) {
  return useCallback(() => {
    const video = webcamRef.current?.video;
    if (video && video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      setIsVideoReady(true);
      setErrorState(null);
    }
  }, [webcamRef, setIsVideoReady, setErrorState]);
}
